import React, { PureComponent } from 'react';
import SectionTypeText from '../text';

const Item = ({ body }) => {
  return (
    <div className="section-list__list-item" dangerouslySetInnerHTML={{ __html: body }}/>
  );
};
const ListOfItems = ({ items }) => {
  return (
    <div className="row section-list">
      {
        items.map((itemObj, index) => {
          return (
            <div key={index} className="col-lg-3 col-md-6 col-xs-12">
              <Item {...itemObj}/>
            </div>
          );
        })
      }
    </div>
  );
};
export default class SectionTypeList extends PureComponent {

  render() {
    const { items } = this.props;
    return (
      <div>
        <SectionTypeText {...this.props}/>
        <ListOfItems items={items}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/type-of-sections/list/index.js